export default "__VITE_PUBLIC_ASSET__646b25c1__"